import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { LaunchesDate } from "@oldDashboard/legacyModels/launchesDate.model";
import { Chart } from "@oldDashboard/legacyModels/chart.model";
import { setLaunchDatesAction } from "@oldDashboard/legacyActions/dashboardClient";

interface LaunchTileProps { launchSelected: String, timePeriodSelected: String, searching: boolean }
const useLaunchDateTile = (props:LaunchTileProps) => {
    const [chartData, setChartData] = useState<Chart>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchLaunchesDate();
    }, [props.searching, props.launchSelected]);
    
    
    const buildChartData = (launchDates: LaunchesDate[]) : Chart => {
       return {
            series: launchDates.map((item)=>Number(item.y)),
            options: {
                labels: [ "Days Remaining","Launch Duration"],
                chart: {
                    type: 'donut',
                    height: 290,
                    events: {
                        mounted: (chart:any) => {
                            chart.windowResizeHandler();
                        }
                        },
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'left', 
                    inverseOrder: true,
            },
                colors: launchDates.map(item=>item.color),
              

                dataLabels: {
                    enabled: true,
                    formatter: function (_series: number[], opts: any) {
                        return opts.w.globals.series[opts.seriesIndex];
                    },
                    textAnchor: 'middle',
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 1,
                        color: '#000',
                        opacity: 0.45
                    }
                },

            }
        };
    }

    const fetchLaunchesDate = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getLaunchDatesData(props.launchSelected, props.timePeriodSelected);
            if (response) {
                setLaunchDatesAction(response);
                const data = buildChartData(response);
                setChartData(data)
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, chartData, fetchLaunchesDate }
}

export default useLaunchDateTile